// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-e82c5d32] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.nc-chip[data-v-e82c5d32] {
  --chip-size: 24px;
  --chip-radius: calc(var(--chip-size) / 2);
  height: var(--chip-size);
  max-width: fit-content;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: var(--chip-radius);
  background-color: var(--color-background-hover);
}
.nc-chip--primary[data-v-e82c5d32] {
  background-color: var(--color-primary-element);
  color: var(--color-primary-element-text);
}
.nc-chip--secondary[data-v-e82c5d32] {
  background-color: var(--color-primary-element-light);
  color: var(--color-primary-element-light-text);
}
.nc-chip--no-actions .nc-chip__text[data-v-e82c5d32] {
  padding-inline-end: calc(1.5 * var(--default-grid-baseline));
}
.nc-chip--no-icon .nc-chip__text[data-v-e82c5d32] {
  padding-inline-start: calc(1.5 * var(--default-grid-baseline));
}
.nc-chip__text[data-v-e82c5d32] {
  flex: 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  text-wrap: nowrap;
}
.nc-chip__icon[data-v-e82c5d32] {
  flex: 0 0 var(--chip-size);
  margin-inline-end: var(--default-grid-baseline);
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  height: var(--chip-size);
  width: var(--chip-size);
}
.nc-chip__actions[data-v-e82c5d32] {
  flex: 0 0 var(--chip-size);
  --default-clickable-area: var(--chip-size);
  --border-radius-element: var(--chip-radius);
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcChip-BNLuZgd6.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,wBAAwB;EACxB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;EACjC,+CAA+C;AACjD;AACA;EACE,8CAA8C;EAC9C,wCAAwC;AAC1C;AACA;EACE,oDAAoD;EACpD,8CAA8C;AAChD;AACA;EACE,4DAA4D;AAC9D;AACA;EACE,8DAA8D;AAChE;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,0BAA0B;EAC1B,+CAA+C;EAC/C,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE,0BAA0B;EAC1B,0CAA0C;EAC1C,2CAA2C;AAC7C","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-e82c5d32] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.nc-chip[data-v-e82c5d32] {\n  --chip-size: 24px;\n  --chip-radius: calc(var(--chip-size) / 2);\n  height: var(--chip-size);\n  max-width: fit-content;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  border-radius: var(--chip-radius);\n  background-color: var(--color-background-hover);\n}\n.nc-chip--primary[data-v-e82c5d32] {\n  background-color: var(--color-primary-element);\n  color: var(--color-primary-element-text);\n}\n.nc-chip--secondary[data-v-e82c5d32] {\n  background-color: var(--color-primary-element-light);\n  color: var(--color-primary-element-light-text);\n}\n.nc-chip--no-actions .nc-chip__text[data-v-e82c5d32] {\n  padding-inline-end: calc(1.5 * var(--default-grid-baseline));\n}\n.nc-chip--no-icon .nc-chip__text[data-v-e82c5d32] {\n  padding-inline-start: calc(1.5 * var(--default-grid-baseline));\n}\n.nc-chip__text[data-v-e82c5d32] {\n  flex: 1 auto;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-wrap: nowrap;\n}\n.nc-chip__icon[data-v-e82c5d32] {\n  flex: 0 0 var(--chip-size);\n  margin-inline-end: var(--default-grid-baseline);\n  line-height: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  height: var(--chip-size);\n  width: var(--chip-size);\n}\n.nc-chip__actions[data-v-e82c5d32] {\n  flex: 0 0 var(--chip-size);\n  --default-clickable-area: var(--chip-size);\n  --border-radius-element: var(--chip-radius);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
